import { updateOption } from "api";
import { Error } from "utils/Response";
import { SetDecisionDetails } from "../GetDecisionDetails/action";
import { ActionTypes } from "./types";

export const UpdateOption = (Data) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const config = Data.isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
    const { data, status } = await updateOption(Data, config);
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
    if (status === 200) {
      dispatch(SetDecisionDetails(data));
      return data;
    }
    // Return result so callers can await and act on API status
    return { data, status };
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
    throw error;
  }
};
